import {Component, Input, OnInit} from '@angular/core';
import {MediumDTO} from 'src/app/services/api/api';

@Component({
  selector: 'sb-comp-embedded-media',
  templateUrl: './sb-embedded-media.component.html',
  styleUrls: ['./sb-embedded-media.component.scss'],
  standalone: false,
})
export class SbEmbeddedMediaComponent implements OnInit {
  @Input() media: MediumDTO[];

  constructor() {}

  ngOnInit(): void {}
}
